export const DashboardTypes = {
  CodingIssues: 0,
  Tasks: 1,
  DelegatedWork: 2,
  DiseaseManagement: 3
}

//TODO Typescripts type system allows us to constrain a number to the above object constants
// might be able to use a typescript mapped type too
export const componentIdToComponentName = (componentId: number): string => {
  switch (componentId) {
    case DashboardTypes.CodingIssues:
      return 'CodingProblems'
    case DashboardTypes.Tasks:
      return 'Tasks'
    case DashboardTypes.DelegatedWork:
      return 'DelegatedWork'
    case DashboardTypes.DiseaseManagement:
      return 'DiseaseManagement'
    default:
      return ''
  }
}
